<template>
  <el-dialog class="wrapper" :title="$t('lcd.NewAdd.Select Pricetag')" :visible.sync="dialogVisible">
    <div class="searchWrap">
      <el-input
        v-model="form.templateName"
        size="small"
        :placeholder="$t('lcd.Template.Please Enter Template Name')"
        @change="handleSearchChange"
        class="searchInput"
        clearable
      ></el-input>
      <el-select
        size="small"
        v-model="form.templateSize"
        @change="handleSearchChange"
        class="searchSelect"
        :placeholder="$t('lcd.Template.Please Select Template Resolution')"
        clearable
        allow-create
        ref="resolutionRef"
        @clear="clearResolution"
      >
        <el-option
          v-for="item in priceTagSizeList()"
          :key="item.id"
          :label="item.label"
          :value="item.value"
          @click.native="opClick"
        >
        </el-option>
        <el-option
          label="0"
          value="0"
          disabled
          style="height: 40px; line-height: 40px; cursor: default"
        >
          <el-input
            v-model="customResolution.width"
            controls-position="right"
            :max="1280"
            size="mini"
            :placeholder="$t('lcd.Template.Width')"
            type="number"
            style="width: 60px"
            class="resolutionInput"
          ></el-input>
          <el-input
            v-model="customResolution.height"
            controls-position="right"
            :max="1280"
            size="mini"
            type="number"
            :placeholder="$t('lcd.Template.Height')"
            style="width: 60px"
            class="resolutionInput"
          ></el-input>
          <el-button
            @click="resolutionConfirm"
            style="
              padding: 0 15px;
              height: 28px;
              line-height: 26px;
              font-size: 12px;
              border-radius: 4px;
              float: right;
              margin-top: 7px;
            "
            >{{$t('button.Sure')}}</el-button
          >
        </el-option>
      </el-select>
    </div>
    <!-- {{priceTagOptions}} -->
    <div style="padding: 0px">
      <el-row class="img-row" :gutter="18">
        <el-col
          v-for="priceTag in priceTagOptions.priceTagList"
          :key="priceTag.templateId"
          :xs="12"
          :sm="8"
          :md="8"
          :lg="6"
          :xl="6"
          style="margin-bottom: 18px"
        >
          <!-- {{priceTag}} -->
          <div class="imgWrap">
            <div class="piexlsInfo">
              {{ priceTag.width }}x{{ priceTag.height }}
            </div>
            <img
              :src="priceTag.cover"
              :style="{
                'max-width': '100%',
                'min-height': '120px',
                'max-height': '160px',
                height: 'auto',
              }"
              alt=""
              @click="handleSelectPriceTag(priceTag)"
            />
          </div>
          <div class="templateInfo">
            <span class="templateName">{{ priceTag.templateName }}</span>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-pagination
      layout="total, sizes, prev, pager, next"
      :current-page="priceTagOptions.current"
      :total="priceTagOptions.total"
      :page-size="priceTagOptions.size"
      :page-sizes="priceTagOptions.sizes"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      background
      style="text-align: right"
      v-if="priceTagOptions.priceTagList.length > 0"
    />
    <el-empty
      v-if="priceTagOptions.priceTagList.length < 1"
      :image-size="200"
    ></el-empty>
  </el-dialog>
</template>

<script>
import store from "../../../store/index.js";
import { attrPriceTag } from "../../../utils/component-attribute";
import { idxOf } from "../../../utils/common.js";
import { priceTagSizeList } from "@/libs/enum";

export default {
  name: "SelectPriceTag",
  inject: ["getNewComponentId"],
  data() {
    return {
      priceTagSizeList,
      form: {
        templateName: "",
        templateSize: "",
      },
      customResolution: {
        width: "",
        height: "",
      },
    };
  },
  props: {
    priceTagOptions: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return store.state.selectPriceTagDialogVisible;
      },
      set(val) {
        return store.updateSelectPriceTagDialogVisible(val);
      },
    },
  },
  methods: {
    clearResolution() {
      this.customResolution = {
        width: "",
        height: "",
      };
    },
    // 自定义素材分辨率确认
    resolutionConfirm() {
      let resolutionRef = this.$refs.resolutionRef;
      console.log(resolutionRef);
      resolutionRef.visible = false;
      this.form.templateSize =
        this.customResolution.width > 0 && this.customResolution.height > 0
          ? this.customResolution.width + "*" + this.customResolution.height
          : "";
    },
    handleSearchChange() {
      const val = {
        ...this.form,
      };

      console.log(val)
      this.$emit("search-change", val);
    },
    handleCurrentChange(val) {
      this.$emit("current-change", val);
    },
    handleSizeChange(val) {
      this.$emit("size-change", val);
    },
    handleSelectPriceTag(priceTag) {
      console.log(priceTag);
      let conf;
      // 添加价签组件
      conf = JSON.parse(JSON.stringify(attrPriceTag));
      conf.componentId = this.getNewComponentId();
      conf.width = priceTag.width;
      conf.height = priceTag.height;
      conf.priceTagId = priceTag.templateId;
      conf.priceTagName = priceTag.templateName;
      conf.priceTagList.push({
        duration: 3,
        priceTagSrc: priceTag.cover,
        priceTagId: priceTag.templateId,
      });
      store.addComponent(conf);

      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.imgWrap {
  width: 100%;
  height: 160px;
  background-color: #f2f2f2;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .piexlsInfo {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.35);
    padding: 3px 5px;
    font-size: 12px;
    border-radius: 3px;
    top: 5px;
    right: 5px;
    color:#fff;
  }
  img {
    max-height: 160px;
    width: auto;
  }
}
.templateInfo {
  padding: 8px 0;
}
.wrapper {
  ::v-deep .el-dialog {
    width: 1008px;
    margin-top: 5vh !important;
  }
  ::v-deep .el-dialog__header {
    button {
      font-size: 20px;
    }
  }

  ::v-deep .el-dialog__body {
    padding-top: 0;
  }

  .img-row {
    .el-col {
      // width: calc(33.33333% - 12px);
      // margin: 6px;

      img {
        cursor: pointer;
      }
    }
  }
}

.searchWrap {
  width: 100%;
  padding: 15px 0;
  .searchInput {
    width: 160px;
  }
  .searchSelect {
    margin-left: 10px;
  }
}

::v-deep .el-pagination.is-background button,
.el-pagination.is-background button span,
.el-pagination.is-background .el-pager li {
  height: 28px !important;
  line-height: 28px !important;
}
::v-deep .el-pagination.is-background .el-pager li {
  height: 28px !important;
  line-height: 28px !important;
}
.elCard {
  position: relative;
  .format {
    // width: 40px;
    font-size: 12px;
    line-height: 16px;
    position: absolute;
    background-color: rgba($color: #000000, $alpha: 0.4);
    padding: 3px 8px;
    color: #fff;
    right: 0;
    top: 0;
    border-radius: 0 3px 0 3px;
    z-index: 2;
  }
}
.imageName {
  padding: 5px 10px;
  height: 50px;
  // background-color: rgba(0, 0, 0,.2);
  // color:#fff;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: -1px;
  right: -1px;
  z-index: 2;
  font-size: 13px;
  line-height: 16px;
}
</style>
